<template>
  <div id="guideline" class="guideline">
    <headline>Guideline</headline>
    <router-link to="guide" class="guide_link">
      <guide-title tag_type="span"></guide-title>
    </router-link>
  </div>
</template>

<script>
import headline from './common/headline'
import guideTitle from '../shared/guide_title'

export default {
  name: 'Guideline',
  components: { headline, guideTitle }
}
</script>

<style lang="scss" scoped>
@import '@/stylesheets/variables';

div.guideline {
  text-align: center;
}

a.guide_link {
  display: inline-block;
  text-decoration: none;
  width: 80%;
}

div.guideline ::v-deep .guide_title {
  color: $text-white;
  text-align: center;
}
</style>
